/** Clears the persisted Apollo cache (localForage + localStorage) and resets to defaults. */
export const clearApolloCache = async (): Promise<void> => {
    const { persistor } = await import('../../components/ApolloClient/apolloSingletons')
    return persistor.purge()
}
